// ** React query Imports
import { useInfiniteQuery } from "@tanstack/react-query";

// ** Config apisauce
import api from "../../app/api";

// ** Helpers imports
import { timeout } from "../../helpers";

// ** Types Imports
import { CustomerByModel, CustomerList } from "./types";
import { STEP_LIMIT } from "./types";

type PageParamType = {
  page: number;
  size: number;
  currentFirstPosition: number;
};

const defaultPageParam = {
  page: 1,
  size: STEP_LIMIT,
  currentFirstPosition: 0,
};

export function useCustomersInfinite(params: CustomerByModel) {
  async function getCustomers(
    pageParam: PageParamType,
    params: CustomerByModel
  ): Promise<CustomerList> {
    await timeout(1000);
    const response = await api.post<CustomerList>("admin/customers/paginated", {
      ...params,
      customersData: {
        ...params.customersData,
        currentFirstPosition: pageParam.currentFirstPosition,
        step: pageParam.size,
      },
    });

    if (!response.ok || !response.data) {
      throw response;
    }

    return response.data;
  }

  return useInfiniteQuery({
    queryKey: ["CustomersInfinite", ...Object.values(params)],
    queryFn: ({ pageParam = defaultPageParam }) =>
      getCustomers(pageParam, params),

    getNextPageParam: (lastPage, allPages) => {
      const totalItems = lastPage.customersData.totalItems;
      const totalPages = Math.ceil(totalItems / STEP_LIMIT);
      const penultimatePage = totalPages - 1;
      const items = allPages.flatMap((page) => page.customers) || [];
      const offset = totalItems % STEP_LIMIT || STEP_LIMIT;
      const isPenultimatePage = allPages.length === penultimatePage;
      if (items.length === totalItems) {
        return undefined;
      } else {
        return {
          page: allPages.length + 1,
          size: isPenultimatePage ? offset : STEP_LIMIT,
          currentFirstPosition: items.length + 1,
        };
      }
    },
  });
}
